export const getLanguagesList = () => {
    return languagesList.sort((a, b) => a.value.localeCompare(b.value));
};

const languagesList = [
    { value: 'albanian', label: '🇦🇱 Albanian (Shqip)' },
    { value: 'amharic', label: '🇪🇹 Amharic (አማርኛ)' },
    { value: 'arabic', label: '🇸🇦 Arabic (العربية)' },
    { value: 'armenian', label: '🇦🇲 Armenian (Հայերեն)' },
    { value: 'bengali', label: '🇧🇩 Bengali (বাংলা)' },
    { value: 'bosnian', label: '🇧🇦 Bosnian (Bosanski)' },
    { value: 'bulgarian', label: '🇧🇬 Bulgarian (Български)' },
    { value: 'burmese', label: '🇲🇲 Burmese (မြန်မာ)' },
    { value: 'catalan', label: '🇪🇸 Catalan (Català)' },
    { value: 'chinese', label: '🇨🇳 Chinese (中文)' },
    { value: 'croatian', label: '🇭🇷 Croatian (Hrvatski)' },
    { value: 'czech', label: '🇨🇿 Czech (Čeština)' },
    { value: 'danish', label: '🇩🇰 Danish (Dansk)' },
    { value: 'dutch', label: '🇳🇱 Dutch (Nederlands)' },
    { value: 'english', label: '🇬🇧 English (English)' },
    { value: 'estonian', label: '🇪🇪 Estonian (Eesti)' },
    { value: 'finnish', label: '🇫🇮 Finnish (Suomi)' },
    { value: 'french', label: '🇫🇷 French (Français)' },
    { value: 'georgian', label: '🇬🇪 Georgian (ქართული)' },
    { value: 'german', label: '🇩🇪 German (Deutsch)' },
    { value: 'swiss-german', label: '🇨🇭 Swiss German (Schweizerdeutsch)' },
    {
        value: 'swiss-standard-german-(high-german)',
        label: '🇨🇭 Swiss Standard German (High German)',
    },
    { value: 'greek', label: '🇬🇷 Greek (Ελληνικά)' },
    { value: 'gujarati', label: '🇮🇳 Gujarati (ગુજરાતી)' },
    { value: 'hindi', label: '🇮🇳 Hindi (हिन्दी)' },
    { value: 'hungarian', label: '🇭🇺 Hungarian (Magyar)' },
    { value: 'icelandic', label: '🇮🇸 Icelandic (Íslenska)' },
    { value: 'indonesian', label: '🇮🇩 Indonesian (Bahasa Indonesia)' },
    { value: 'italian', label: '🇮🇹 Italian (Italiano)' },
    { value: 'japanese', label: '🇯🇵 Japanese (日本語)' },
    { value: 'kannada', label: '🇮🇳 Kannada (ಕನ್ನಡ)' },
    { value: 'kazakh', label: '🇰🇿 Kazakh (Қазақша)' },
    { value: 'korean', label: '🇰🇷 Korean (한국어)' },
    { value: 'latvian', label: '🇱🇻 Latvian (Latviešu)' },
    { value: 'lithuanian', label: '🇱🇹 Lithuanian (Lietuvių)' },
    { value: 'macedonian', label: '🇲🇰 Macedonian (Македонски)' },
    { value: 'malay', label: '🇲🇾 Malay (Bahasa Melayu)' },
    { value: 'malayalam', label: '🇮🇳 Malayalam (മലയാളം)' },
    { value: 'marathi', label: '🇮🇳 Marathi (मराठी)' },
    { value: 'mongolian', label: '🇲🇳 Mongolian (Монгол)' },
    { value: 'norwegian', label: '🇳🇴 Norwegian (Norsk)' },
    { value: 'persian', label: '🇮🇷 Persian (فارسی)' },
    { value: 'polish', label: '🇵🇱 Polish (Polski)' },
    { value: 'portuguese', label: '🇵🇹 Portuguese (Português)' },
    { value: 'punjabi', label: '🇮🇳 Punjabi (ਪੰਜਾਬੀ)' },
    { value: 'romanian', label: '🇷🇴 Romanian (Română)' },
    { value: 'russian', label: '🇷🇺 Russian (Русский)' },
    { value: 'serbian', label: '🇷🇸 Serbian (Српски)' },
    { value: 'slovak', label: '🇸🇰 Slovak (Slovenčina)' },
    { value: 'slovenian', label: '🇸🇮 Slovenian (Slovenščina)' },
    { value: 'somali', label: '🇸🇴 Somali (Soomaali)' },
    { value: 'spanish', label: '🇪🇸 Spanish (Español)' },
    { value: 'swahili', label: '🇰🇪 Swahili (Kiswahili)' },
    { value: 'swedish', label: '🇸🇪 Swedish (Svenska)' },
    { value: 'tagalog', label: '🇵🇭 Tagalog (Tagalog)' },
    { value: 'tamil', label: '🇮🇳 Tamil (தமிழ்)' },
    { value: 'telugu', label: '🇮🇳 Telugu (తెలుగు)' },
    { value: 'thai', label: '🇹🇭 Thai (ไทย)' },
    { value: 'turkish', label: '🇹🇷 Turkish (Türkçe)' },
    { value: 'ukrainian', label: '🇺🇦 Ukrainian (Українська)' },
    { value: 'urdu', label: '🇵🇰 Urdu (اردو)' },
    { value: 'vietnamese', label: '🇻🇳 Vietnamese (Tiếng Việt)' },
];
